import { gql } from "@apollo/client";

export const InstalledBaseNodeReportFile = gql`
    query InstalledBaseNodeReportFile ($id: ID!) {
        installedBaseNode(id: $id) {
            id
            fileList {
                installedBaseNodeFiles {
                    id
                    filename
                    file {
                        id
                        basename
                        link
                    }
                }
            }
        }
    }
`;
